export default "__VITE_ASSET__BZA0xqm5__"